module.exports = __webpack_public_path__ + "img/vegetable-sprouts-350x184.1273c6eb.jpg";